import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetCandidateProfessionalApiResponse, IGetCandidateProfessionalPayload } from '../types';

export const getCandidateProfessional = async (
  payload: IGetCandidateProfessionalPayload,
): Promise<IGetCandidateProfessionalApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetCandidateProfessionalApiResponse>(
    `/recruitment-service/candidates/professionals/${payload.professionalId}`,
    {
      headers,
      params: { postingId: payload.postingId },
    },
  );

  return response.data;
};
